import React, { useState } from "react";
import AuditLog from "./AuditLog";
import "../styles/login.css";

const SecureAuditLog = () => {
  const [code, setCode] = useState("");
  const [unlocked, setUnlocked] = useState(
    sessionStorage.getItem("auditUnlocked") === "1",
  );

  const expectedCode =
    process.env.REACT_APP_AUDIT_ACCESS_CODE || "1234";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === expectedCode) {
      setUnlocked(true);
      sessionStorage.setItem("auditUnlocked", "1");
    } else {
      alert("Incorrect audit access password.");
    }
  };

  if (unlocked) {
    return <AuditLog />;
  }

  return (
    <div className="login-page d-flex justify-content-center align-items-center">
      <div className="login-card shadow-sm p-5">
        <h2 className="login-title mb-3">Audit Log Access</h2>
        <p className="login-subtitle mb-4">
          Enter the audit access password to view logs.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-floating mb-3">
            <input
              type="password"
              id="auditPassword"
              className="form-control rounded-3 login-input"
              placeholder="Audit password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
            <label htmlFor="auditPassword">Audit access password</label>
          </div>
          <button type="submit" className="btn login-btn w-100 fw-bold">
            Unlock
          </button>
        </form>
      </div>
    </div>
  );
};

export default SecureAuditLog;

